/** Задержка анимации в компонентах анимации */
export enum TransitionDuration {
  /** Базовая */
  base = 200
}
